import { render, staticRenderFns } from "./TempReceipt.vue?vue&type=template&id=e6a0de98&scoped=true&"
import script from "./TempReceipt.vue?vue&type=script&lang=js&"
export * from "./TempReceipt.vue?vue&type=script&lang=js&"
import style0 from "./TempReceipt.vue?vue&type=style&index=0&id=e6a0de98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a0de98",
  null
  
)

export default component.exports